import { ADVANCED_ONBOARDING } from '../constants'

export const setReturnFlowLocalStorage = (returnFlowParam) => {
  if (returnFlowParam === ADVANCED_ONBOARDING) {
    localStorage.setItem('returnFlow', returnFlowParam)
  }
}

export const getReturnFlowLocalStorage = () => localStorage.getItem('returnFlow')
